// Localização: frontend/src/pages/Assinatura/FalhaPage.jsx
// Página de falha após tentativa de assinatura

import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { XCircle, ArrowLeft, Mail } from 'lucide-react';
import PrimaryButton from '../../components/Common/PrimaryButton';

const FalhaPage = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const status = searchParams.get('status');
    const paymentId = searchParams.get('payment_id');

    const getMensagemErro = () => {
        // Verificar se o erro é sobre conta de teste
        const errorMessage = searchParams.get('error') || '';
        const isTestAccountError = errorMessage.includes('teste') || 
                                   errorMessage.includes('test') ||
                                   window.location.href.includes('test');

        if (isTestAccountError || status === 'test_account_error') {
            return {
                titulo: 'Erro no Processamento',
                mensagem: 'Ocorreu um erro ao processar sua assinatura. Por favor, tente novamente ou entre em contato com o suporte.',
                instrucoes: false
            };
        }

        switch (status) {
            case 'rejected':
                return {
                    titulo: 'Pagamento Recusado',
                    mensagem: 'Seu pagamento foi recusado. Verifique os dados do cartão ou tente outro método de pagamento.'
                };
            case 'cancelled':
                return {
                    titulo: 'Pagamento Cancelado',
                    mensagem: 'O pagamento foi cancelado. Você pode tentar novamente quando estiver pronto.'
                };
            case 'pending':
                return {
                    titulo: 'Pagamento Pendente',
                    mensagem: 'Seu pagamento está sendo processado. Você receberá uma confirmação por e-mail quando for aprovado.'
                };
            default:
                return {
                    titulo: 'Erro no Processamento',
                    mensagem: 'Ocorreu um erro ao processar sua assinatura. Por favor, tente novamente ou entre em contato com o suporte.'
                };
        }
    };

    const { titulo, mensagem, instrucoes } = getMensagemErro();

    return (
        <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white flex items-center justify-center p-4">
            <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center">
                <div className="mb-6">
                    <XCircle className="h-20 w-20 text-red-500 mx-auto" />
                </div>
                <h1 className="text-3xl font-bold text-gray-900 mb-2">
                    {titulo}
                </h1>
                <p className="text-gray-600 mb-6">
                    {mensagem}
                </p>

                {instrucoes && (
                    <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6 text-left">
                        <h3 className="font-semibold text-yellow-900 mb-2">
                            Como resolver:
                        </h3>
                        {/* Instruções serão atualizadas quando a integração com Stripe for implementada */}
                    </div>
                )}

                {paymentId && (
                    <div className="bg-gray-50 rounded-lg p-4 mb-6 text-left">
                        <p className="text-sm text-gray-500">ID do Pagamento:</p>
                        <p className="font-mono text-xs text-gray-700 break-all">{paymentId}</p>
                    </div>
                )}

                <div className="space-y-3">
                    <PrimaryButton
                        onClick={() => navigate('/pricing')}
                        className="w-full bg-higeia-dark hover:bg-higeia-medium"
                    >
                        Tentar Novamente
                        <ArrowLeft className="h-5 w-5 ml-2" />
                    </PrimaryButton>

                    <button
                        onClick={() => window.location.href = 'mailto:suporte@higeia.tech?subject=Problema com Assinatura'}
                        className="w-full flex items-center justify-center px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
                    >
                        <Mail className="h-4 w-4 mr-2" />
                        Contatar Suporte
                    </button>

                    <button
                        onClick={() => navigate('/dashboard')}
                        className="w-full text-sm text-gray-500 hover:text-gray-700 transition-colors"
                    >
                        Voltar para Dashboard
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FalhaPage;

